import { Link } from "react-router-dom";
import { HiOutlineLockClosed } from "react-icons/hi2";

const TickerLimitBanner = ({ message, theme = "light", className = "" }) => {
  if (!message) return null;
  const isDark = theme === "dark";

  return (
    <div
      role="alert"
      className={`rounded-xl border px-3 py-3 sm:px-4 ${className} ${
        isDark
          ? "border-amber-500/40 bg-amber-500/10 text-amber-100"
          : "border-amber-300 bg-amber-50 text-amber-950"
      }`}
    >
      <div className="flex gap-2.5">
        <HiOutlineLockClosed
          className={`mt-0.5 shrink-0 ${isDark ? "text-amber-400" : "text-amber-600"}`}
          size={20}
        />
        <div className="min-w-0 flex-1 space-y-1.5">
          <p className="text-sm font-semibold leading-snug">{message.headline}</p>
          <p className={`text-xs leading-relaxed ${isDark ? "text-amber-200/90" : "text-amber-900/80"}`}>
            {message.detail}
          </p>
          <Link
            to="/payment"
            className={`inline-flex text-xs font-bold underline underline-offset-2 ${
              isDark ? "text-amber-300 hover:text-amber-200" : "text-indigo-700 hover:text-indigo-900"
            }`}
          >
            Subscribe for unlimited ticker access
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TickerLimitBanner;
